import { React, useState } from "react";
import "./Footer.css";
import white from "../../assets/whitefooter.svg";
import logowaheed from "../../assets/icons/waheedwhitelogo.svg";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import footerbg from "../../assets/footerbg.svg";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        height: "auto",
        background: "#022539",
      }}
    >
      <div className="line_container">
        <img src={white} className="whitehead" />
      </div>

      <div className="footer-container">
        <img src={footerbg} className="footerbg" />
        <div className="footer-column social-links">
          <h3>{t("footer.social_links")}</h3>

          {/* <a href="https://www.facebook.com/yourprofile" target="_blank" rel="noopener noreferrer">
  <button className="icon-button">
    <FacebookIcon />
  </button>
</a> */}

          <a
            href="https://www.instagram.com/aljassas2010/profilecard/?igsh=MWM2M3loc2RxNmk4Nw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="icon-button">
              <InstagramIcon />
            </button>
          </a>

          <a
            href="https://x.com/Waheed_Aljassas"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="icon-button">
              <XIcon />
            </button>
          </a>

          <a
            href="https://www.linkedin.com/in/waheed-al-jassas-mba-fr-ilm-fm-0243b332?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="icon-button">
              <LinkedInIcon />
            </button>
          </a>
        </div>

        <div className="footer-links">
          <h3>{t("footer.quick_links")}</h3>
          <ul>
            <li>
              <a href="/">{t("footer.home")}</a>
            </li>
            <li>
              <a href="#investments">{t("footer.investments")}</a>
            </li>
            <li>
              <a href="#achievements">{t("footer.achievements")}</a>
            </li>
            <li>
              <a href="/investmentRequest">{t("footer.contact")}</a>
            </li>
          </ul>
        </div>

        <div className="company-desc">
          <img
            src={logowaheed}
            style={{ color: "white" }}
            className="logowaheed"
          />

          <h3>{t("footer.company_name")}</h3>
          <p>{t("footer.company_desc")}</p>
        </div>
      </div>
      <p className="p-footer">{t("footer.copyright")}</p>
    </div>
  );
}
